import React from 'react';
// import { Link } from 'gatsby';
import { Section } from 'src/components/Section';
import { SubtitleDescription, Paragraph } from 'src/components/Typography';
import colors from 'src/style/colors';
import { DayTitle, DayText } from 'src/components/Bootcamp/TypicalDay/elements';
import { mediaQueries } from 'src/style/breakpoints';
import { UppercaseHeading, LocationAndHours } from './elements';
import Rocket from 'src/data/images/new_rocket.svg';

const TypicalWeek = React.memo(({ id }) => {
  return (
    <Section
      theme="dark"
      id={id}
      css={{
        position: 'relative',
        paddingBottom: 0,
        // paddingTop: 0,
        [mediaQueries.phoneOnly]: {
          paddingTop: 0,
          paddingBottom: 0,
        },
        [mediaQueries.desktopUp]: {
          // paddingTop: 0,
          paddingBottom: 0,
        },
      }}
    >
      <div
        css={{
          position: 'absolute',
          display: 'none',
          [mediaQueries.mediumDesktopUp]: {
            display: 'block',
            // top: 40,
            // right: '5%',
            top: 89,
            right: 65,
          },
          ['@media only screen and (min-width: 1545px)']: { right: 125 },
        }}
      >
        <img
          src={Rocket}
          alt="illustration fusée"
          css={{ width: 152, height: 132, transform: 'rotate(90deg)' }}
        />
      </div>

      <div
        css={{
          display: 'flex',
          marginBottom: 30,
          flexDirection: 'column',
          [mediaQueries.tabletLandscapeUp]: {
            flexDirection: 'row',
          },
        }}
      >
        <div css={{ flex: 1 }}>
          <UppercaseHeading>Chaque semaine</UppercaseHeading>
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              [mediaQueries.tabletLandscapeUp]: {
                flexDirection: 'row',
              },
            }}
          >
            <div
              css={{
                flex: 1,
                [mediaQueries.tabletLandscapeUp]: {
                  paddingRight: 40,
                },
                [mediaQueries.desktopUp]: {
                  paddingRight: 40,
                },
              }}
            >
              <SubtitleDescription css={{ color: colors.yellow }}>Mardi soir</SubtitleDescription>
              <LocationAndHours>En téléprésentiel pendant 3 heures, de 19h à 22h</LocationAndHours>

              <Paragraph
                css={{ display: 'flex', padding: 0, flexDirection: 'row', alignItems: 'center' }}
              >
                <DayTitle css={{ paddingRight: 5 }}> Corrections</DayTitle>
              </Paragraph>
              <DayText css={{ paddingBottom: 25 }}>
                Le formateur commencera par la correction des exercices du précédent samedi.
              </DayText>
              <Paragraph
                css={{ display: 'flex', padding: 0, flexDirection: 'row', alignItems: 'center' }}
              >
                <DayTitle css={{ paddingRight: 5 }}>Cours</DayTitle>
              </Paragraph>
              <DayText css={{ paddingBottom: 25 }}>
                Ensuite, de nouvelles notions seront abordées pour enchaîner sur de nouveaux
                exercices.
              </DayText>
            </div>
            <div
              css={{
                flex: 1,
                [mediaQueries.tabletLandscapeUp]: {
                  paddingRight: 40,
                },
                [mediaQueries.desktopUp]: {
                  paddingRight: 40,
                },
              }}
            >
              <SubtitleDescription css={{ color: colors.yellow }}>Jeudi soir</SubtitleDescription>
              <LocationAndHours>En téléprésentiel pendant 3 heures, de 19h à 22h</LocationAndHours>

              <Paragraph
                css={{ display: 'flex', padding: 0, flexDirection: 'row', alignItems: 'center' }}
              >
                <DayTitle css={{ paddingRight: 5 }}>Exercices</DayTitle>
              </Paragraph>
              <DayText>
                Vous serez accompagné·e pour commencer vos exercices en étant assisté·e par le(s)
                formateur(s). L'idée est que vous ne soyez jamais bloqué·e sur la mise en pratique,
                grâce à un suivi renforcé de la part de vos mentors.
              </DayText>
            </div>
          </div>
        </div>
        <Paragraph
          css={{
            width: '100%',
            textAlign: 'center',
            marginTop: 5,
            [mediaQueries.tabletLandscapeUp]: {
              width: 60,
            },
          }}
        >
          +
        </Paragraph>
        <div css={{ flex: 1 }}>
          <UppercaseHeading>week-end</UppercaseHeading>
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              [mediaQueries.tabletLandscapeUp]: {
                flexDirection: 'row',
              },
            }}
          >
            <div
              css={{
                flex: 1,
                [mediaQueries.tabletLandscapeUp]: {
                  paddingRight: 40,
                },
                [mediaQueries.desktopUp]: {
                  paddingRight: 40,
                },
              }}
            >
              <SubtitleDescription css={{ color: colors.yellow }}>Samedi</SubtitleDescription>
              <LocationAndHours>En téléprésentiel, de 10h à 18h</LocationAndHours>
              <DayTitle>Cours et corrections</DayTitle> - matinée
              <DayText css={{ paddingBottom: 25 }}>
                Les journées commencent toujours par les corrections, puis le formateur enchainera
                sur le cours du jour.
              </DayText>
              <DayTitle>Exercices</DayTitle> - après-midi
              <DayText css={{ paddingBottom: 25 }}>
                Vous réaliserez les exercices du jour, plus complexes et plus nombreux que ceux en
                semaine, mais avec un accompagnement plus poussé.
              </DayText>
            </div>
            <div
              css={{
                flex: 1,
                [mediaQueries.tabletLandscapeUp]: {
                  paddingRight: 40,
                },
                [mediaQueries.desktopUp]: {
                  paddingRight: 40,
                },
              }}
            >
              <SubtitleDescription css={{ color: colors.yellow }}>Dimanche</SubtitleDescription>
              <LocationAndHours>Chez vous, à votre rythme</LocationAndHours>
              <DayTitle>Travail à la maison</DayTitle>
              <DayText css={{ paddingBottom: 25 }}>
                Au moins 4 heures par semaine sont recommandées pour travailler sur les exercices
                qui vous seront donnés pendant les cours. Vous aurez accès à la plateforme de cours
                en ligne pour revoir les notions et trouver des solutions à vos problèmes. Nos
                formateurs resteront disponibles par Slack pour vous aider à progresser.
              </DayText>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
});
export default TypicalWeek;
